<template>

  <div class="home">
    <!--Header off the website-->
    <Headers />
    <!--End Header off the website-->

    <!--section video off the website-->
    <section
      class="section mcb-section mcb-section-video-maim has-video"
      style=""
    >
    <modalCourseDetails :modal="VerModalCourseDetail"   @cerrarModal="VerModalCourseDetail = false" />
      <div class="section_video">
        <video
          autoplay="true"
          loop="true"
          muted="muted"
          playsinline="true"
          :key="videoSrc"
        >
          <source
            type="video/mp4"
            :src="videoSrc"
          />
        </video>
      </div>
      <div class="mcb-background-overlay"></div>
      <div class="section_wrapper">
        <div class="wrap mcb-wrap one">
          <div class="mcb-wrap-inner">
            <div class="column mcb-column mcb-item-video-text two-third">
              <div class="mcb-column-inner mcb-item-column-inner">
                <div class="column_attr mfn-inline-editor">
                 <h3 class="d-block d-md-none">LA MEJOR ACADEMIA DE MICROPIGMENTACIÓN</h3>
                  <h1 class="d-none d-md-block customs-h1">LA MEJOR ACADEMIA DE MICROPIGMENTACIÓN</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--End section video off the website-->

    <!--Section Course off the website-->
    <div id="seccion-cursos">
      <div class="container">
        <CCard class="bg-transparent border-0">
          <CCardHeader class="botonesP text-white">
            <b> CURSOS MAS POPULARES </b>
          </CCardHeader>
          <CCardBody class="px-0">
            <CRow>
              <template>
                <CCol
                  md="6"
                  lg="4"
                  v-for="(item, index) in Cursositems"
                  :key="index"
                  class="d-flex justify-content-center"
                >
                  <div
                    class="card cursor-pointer border-0 course_box"
                  
                    @click="VerModalCourseDetail = item"
                  >
                  <div>
                    <img
                      :src="$apiAdress + '/api/courses/img/' + item.image"
                      class="bd-placeholder-img card-img-top"
                      width="100%"
                      height="180"
                      aria-label="Placeholder: Image cap"
                      role="img"
                    />
                  </div>
                    

                    <div class="card-body  pb-5 botonesP">
                      <div class="text-justify">
                        <h5 class="card-title fw-bold">{{ item.CourseName }}</h5>
                      <p class="card-text text-white">{{ truncateDescription(item.description,120) }}</p>
                      </div>
                     <div class="text-end mt-3">
                        <h5 class="text-white">${{ item.price }}</h5>
                     </div>
                    </div>
                  </div>
                </CCol>
              </template>
            </CRow>
          </CCardBody>
        </CCard>
      </div>
      <!--End Section Course off the website-->
    <!--Btn whatsapp float off the website-->
    <div class="mx-5 floating-button">
      <a
        target="_blank"
        href="https://api.whatsapp.com/send?phone=584245124623&text=*Hola Yaritzy*%0A*Información:* Estoy interesada en adquirir uno de tus cursos"
        class="btn botonesP d-inline-flex align-items-center"
        style="color:#ffffff !important; font-weight:600; letter-spacing:0.5px; padding: 10px 18px; border-radius: 30px; box-shadow: 0 4px 12px rgba(0,0,0,0.5);"
      >
        <span class="mr-2" style="color:#ffffff !important; white-space: nowrap;">Agenda tu Cita</span>
        <i class="fab fa-whatsapp" style="color:#25D366 !important; font-size:1.3rem;"></i>
      </a>
    </div>
    <!--End Btn whatsapp float off the website-->
    </div>
    
    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import { freeSet } from "@coreui/icons";
import General from "@/_mixins/general";
import Headers from "../../containers/Header.vue";
import Footer from "../../containers/TheFooter.vue";
import modalCourseDetails from "./modalCourseDetails";

function detail_curso(id) {
  console.log(id);
  // this.$router.push({
  //   name: "singleCourse",
  //   params: {
  //     id: id,
  //   },
  // });
  // this.modalCourseDetails = true;
}




export default {
  name: "Index",
  mixins: [General],
  freeSet,
  components: {
    Headers,
    Footer,
    modalCourseDetails
  },
  data() {
    return {
      email: "",
      password: "",
      showMessage: false,
      Loading: false,
      message: "",
      collapse: false,
      Productitems: [],
      Cursositems: [],
      currentPage: 1,
      perPage: 5,
      user: "",
      logueado: false,
      VerModalCourseDetail: false,
      videoSrc: require("../../../public/home.mov"),
    };
  },
  methods: {
    detail_curso,
    getRowCount(Productitems) {
      return Productitems.length;
    },
    goRegister() {
      this.$router.push({ path: "register" });
    },
    goLogin() {
      this.$router.push({ path: "login" });
    },
    goDashboard() {
      this.$router.push({ path: "Dashboard" });
    },
    getProducts() {
      let self = this;
      axios
        .get(
          this.$apiAdress +
            "/api/products?token=" +
            localStorage.getItem("api_token")
        )
        .then(function (response) {
          self.Productitems = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getCourses() {
      let self = this;
      axios
        .get(
          this.$apiAdress +
            "/api/courses?token=" +
            localStorage.getItem("api_token")
        )
        .then(function (response) {
          self.Cursositems = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    truncateDescription(text, limit) {
      if (text.length <= limit) {
        return text;
      }
      return text.substring(0, limit) + "...";
    },
    loadVideoResource() {
      let self = this;
      axios
        .get(this.$apiAdress + "/api/site-resources/home_video")
        .then(function (response) {
          if (response.data.url) {
            self.videoSrc = response.data.url;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  mounted: function () {
    this.getCourses();
    this.loadVideoResource();
    localStorage.removeItem("course");
  },
};
</script>
<style scoped>
svg {
  color: white !important;
}

.c-header-brand {
  text-decoration: none;
}
.c-header-nav-item {
  cursor: pointer;
  font-size: 1.032rem;
  height: 100%;
  padding: 13px;
}
.c-header-nav-item:hover {
  border-bottom: 4px solid rgb(182, 108, 204);
}
.nav-link:hover {
  cursor: pointer;
}

/*-------------section video auto-------------*/
.mcb-section-video-maim {
  padding-top: 130px;
  /* background-image: url("../../../public/img/videohome/formacion-en-microblading-scaled.webp")*/;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.section > .mcb-background-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
}
.mcb-section-video-maim .mcb-background-overlay {
  background-color: #00000080;
}
.section.has-video {
  position: relative;
  overflow: hidden;
}
.section.has-video .section_video {
  position: absolute;
  top: 0;
  left: 0;
  min-height: 100%;
  min-width: 100%;
  overflow: hidden;
  width: 100%;
  height: 100vh;
}
.section.has-video .section_video video{
   height: auto;
  width: 100%;
}

.section.has-video .section_wrapper {
  position: relative;
 
}
/* Aplicar height: 70vh; solo en desktop (ancho mínimo de 1024px, por ejemplo) */
@media only screen and (min-width: 1024px) {
  .section.has-video .section_wrapper {
    height: 110vh;
  }
}
.one.mcb-wrap {
  width: auto; 
  padding-bottom: 0; 
  padding-top: 0; 
}
@media only screen and (min-width: 1024px) {
  .one.mcb-wrap {
    width: 100%;
    padding-bottom: 100px;
    padding-top: 100px;
  }
}
.mcb-wrap {
  float: left;
  position: relative;
  z-index: 1;
  box-sizing: border-box;
}
.mcb-wrap,
.mcb-wrap-inner,
.section_wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 20vh;
}
.mcb-column,
.mcb-wrap,
.section {
  background-position: 0 0;
  background-repeat: no-repeat;
}
.h2-xxl {
  font-size: 80px;
  /* line-height: 90px; */
  font-family: "Playfair display";
  color: white;
}
.mcb-section .mcb-wrap .mcb-item-video-text .column_attr {
  text-align: center;
}
.mcb-item-column-inner {
  width: 100%;
  word-break: break-word;
}
.two-third.column {
  width: 100%;
}

.customs-whatsaap{
  z-index: 999;
  text-align: end;
}
.customs-h1{
  margin-top: 25%;
}
/*-------------End section video auto-------------*/
</style>
